import React, { useCallback, CSSProperties, useEffect, useRef } from 'react';
import AnimTabContent from '../anim-tab-content';
import { ARROW_DOWN_ICON } from '@src/slide/domain/ui-model/element-modeles/property/animation/anim-icon';
import { IAnimCategory } from '@src/slide/domain/ui-model/element-modeles/property/animation/constants';
import styles from './index.less';

interface IProps {
    // 点击事件回调，分别传入子元素id和父板块id
    onClick: (childId: string, categoryId?: string) => void;
    // 用于的展示的list
    animCategoryList: IAnimCategory[];
    // 被选中的元素id
    selectedId: string;
    // 容器宽度，默认值362
    width?: number;
    // 容器高度，默认值auto，由内部元素自动撑开
    height?: number | 'auto';
    // 是否展示下拉箭头，默认false不展示
    showArrow?: boolean;
    // 每一项item的样式
    itemStyle?: CSSProperties;
}
const AnimGallery = ({
    onClick,
    animCategoryList,
    selectedId = '',
    width = 362,
    height = 'auto',
    showArrow = false,
    itemStyle = {},
}: IProps) => {
    const ref = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        ref.current?.addEventListener('wheel', preventScrollThrough);

        return () => {
            ref.current?.addEventListener('wheel', preventScrollThrough);
        };
    }, []);

    // 阻止滚动穿透
    const preventScrollThrough = (e: Event) => {
        e.stopPropagation();
    };

    const handleClick = useCallback((itemId: string, categoryId: string) => {
        onClick(itemId, categoryId);
    }, []);

    return (
        <div
            className={styles.gallery}
            ref={ref}
            style={{
                width,
                height,
                justifyContent: showArrow ? 'space-between' : 'center',
                paddingRight: showArrow ? '4px' : '8px',
            }}
        >
            <div className={styles['gallery-left']} style={{ width: showArrow ? width - 28 : width }}>
                {animCategoryList.map((item) => {
                    const { label, children, id } = item;
                    return (
                        <div className={styles['gallery-left-category']} key={id}>
                            <div className={styles['gallery-left-category-label']}>{label}</div>
                            <div className={styles['gallery-left-category-content']}>
                                {children.map((childItem) => {
                                    const { id: childId, label, icon, disabled } = childItem;
                                    return (
                                        <AnimTabContent
                                            id={childId}
                                            icon={icon}
                                            label={label}
                                            key={`${id}-${childId}`}
                                            selected={selectedId === childId}
                                            disabled={disabled}
                                            onClick={(itemId) => {
                                                handleClick(itemId, id);
                                            }}
                                            style={{ padding: '0 4px', ...itemStyle }}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
            </div>
            {showArrow && (
                <div className={styles['gallery-right']}>
                    <img src={ARROW_DOWN_ICON} className={styles['gallery-right-icon']} />
                </div>
            )}
        </div>
    );
};

export default AnimGallery;
